import { useMemo } from "react";
import TabComponent from "../Common/TabComponent";
import ArtistDetailsTabContent from "./ArtistDetailsTabContent";
import DiscographyTabContent from "./DiscographyTabContent";
import CreditsTabContent from "./CreditsTabContent";

interface ArtistTabsProps {
    artist: Artist;
    memberships: Membership[] | null;
    members: Membership[] | null;
    albums: Album[] | null;
    titles: Song[] | null;
    credits: Credits[] | null;
    artist_id: number;
}

const ArtistTabs: React.FC<ArtistTabsProps> = ({
    artist,
    memberships,
    members,
    albums,
    titles,
    credits,
    artist_id
}) => {
    const tabs = useMemo(() => {
        // Wait for all data to be loaded before determining which tabs to show
        if (albums === null || titles === null || credits === null) {
            return [];
        }

        const tabArray = [];

        // Define tabs in priority order
        const discographyTab = {
            id: "DISCOGRAPHY",
            title: "DISCOGRAPHY",
            content: (
                <DiscographyTabContent
                    titles={titles}
                    albums={albums}
                    artist_id={artist_id}
                />
            ),
            shouldShow: albums.length > 0 || titles.length > 0
        };

        const detailsTab = {
            id: "DETAILS",
            title: "DETAILS",
            content: (
                <div className="tab-details">
                    <ArtistDetailsTabContent
                        artist={artist}
                        memberships={memberships}
                        members={members}
                    />
                </div>
            ),
            shouldShow: Boolean(
                (members && members.length > 0) ||
                (memberships && memberships.length > 0)
            )
        };

        const creditsTab = {
            id: "CREDITS",
            title: "CREDITS",
            content: (
                <CreditsTabContent
                    credits={credits}
                    artist_id={artist_id}
                />
            ),
            shouldShow: credits.length > 0
        };

        // Add tabs in priority order if they should be shown
        if (discographyTab.shouldShow) {
            tabArray.push(discographyTab);
        }
        if (detailsTab.shouldShow) {
            tabArray.push(detailsTab);
        }
        if (creditsTab.shouldShow) {
            tabArray.push(creditsTab);
        }

        return tabArray;
    }, [artist, memberships, members, albums, titles, credits, artist_id]);

    // If data is still loading or no tabs are available, return null
    if (tabs.length === 0) {
        return null;
    }

    return (
        <TabComponent
            tabs={tabs}
            defaultTab={tabs[0].id}
            contentClassName="tab-content-scrollable"
        />
    );
};

export default ArtistTabs; 